var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bxs:up-arrow"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.29845 3.38369L5.29844 20.6163C5.29899 20.7907 5.34711 20.9617 5.43763 21.1109C5.52814 21.2601 5.65761 21.3817 5.81212 21.4628C5.96663 21.5438 6.14031 21.5812 6.31448 21.5708C6.48865 21.5605 6.6567 21.5029 6.80055 21.4042L19.2463 12.7879C19.7623 12.4308 19.7623 11.5711 19.2463 11.213L6.80055 2.59674C6.657 2.49701 6.48886 2.43852 6.31441 2.42764C6.13995 2.41675 5.96585 2.45389 5.81101 2.535C5.65618 2.61612 5.52653 2.73812 5.43617 2.88775C5.3458 3.03737 5.29817 3.2089 5.29845 3.38369Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.f2d94240bb787625fb6c8702572f1823.svg";
export { ForwardRef as ReactComponent };